import WarningOverlay from './WarningOverlay';

export default WarningOverlay;
